export default {
  getLocale: (state) => state.locale,
  getCompanyList: (state) => state.companyList,
  getActiveCompany: (state) => state.activeCompany,
};
